import Header from './components/Header';
import Ticker from './components/Ticker';
import HeroBand from './components/HeroBand';
import HeatRank from './components/HeatRank';
import EntBlacklist from './components/EntBlacklist';
import NetBlacklist from './components/NetBlacklist';
import EventZone from './components/EventZone';
import RecapRank from './components/RecapRank';
import TopicFeed from './components/TopicFeed';
import FaqTrust from './components/FaqTrust';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div id="top" className="bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Ticker />
        <HeroBand />
        <HeatRank />
        <EntBlacklist />
        <NetBlacklist />
        <EventZone />
        <RecapRank />
        <TopicFeed />
        <FaqTrust />
      </main>
      <Footer />
    </div>
  );
}